<template>
    <div class="sag-open-window">
        <sag-button
            v-b-modal="'sag-open-window-' + serviceName + '-' + name"
            class="mr-1"
            variant="outline-primary"
        >
            {{ titles.buttonName }}
        </sag-button>

        <b-modal 
            :id="'sag-open-window-' + serviceName + '-' + name" 
            :title="cptTitle.windowTitle"
            @ok="submitEvent"
        >   
            <sag-basic-table
                :title="cptTitle.title"
                :subtitle="cptTitle.subTitle"
                :GridData="GridData"
                :serviceName="serviceName"
                :options="{
                    multiple: false,
                    lineNumber: true,
                    selectCheckBox: false,
                    pageLength: 5
                }"
            >

            </sag-basic-table>
        </b-modal>
    </div>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import SagButton from '@/components/basic/SagButton.vue'
import SagBasicTable from '@/components/sag-basic-table/SagBasicTable.vue'
import SagOpenWindow from './SagOpenWindow'
import { defaultTitle } from './SagOpenWindow'
import { getCurrentInstance } from '@vue/composition-api'
import tools from '@/sag-core/tools'

export default {
    components: {
        BButton,
        BModal,
        SagButton,
        SagBasicTable
    },
    props: {
        name: {
            type: String,
            required: true
        },
        serviceName: {
            type: String,
            required: true
        },
        GridData: {
            type: Object,
            default: ()=>{return {}}
        },
        titles: {
            type: Object,
            default: defaultTitle
        }
    },
    setup(props, { emit }){
        const {
            cptTitle,
            submitEvent
        } = SagOpenWindow(props, emit)

        return {
            cptTitle,
            submitEvent
        }
    }
}
</script>